module.exports = __webpack_public_path__ + "img/atlas-logo.fb486c87.jpg";